import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Spinner from '../../components/generics/Spinner';
import _ from 'lodash';
import queryString from 'query-string';

import ReactPaginate from 'react-paginate';

import Filter from '../../components/generics/Filter';
import ReportHeader from '../../components/generics/ReportHeader';
import ReportWaste from '../../components/reports/ReportWaste';

import NoPermissionMessage from '../../components/generics/NoPermissionMessage';

import { fetchWasteCategories, fetchWasteCategoriesSuccess, fetchWasteCategoriesFailure } from "../../store/inventories/actions";
import {
  fetchInventoryWasteReport,
  fetchInventoryWasteReportSuccess,
  fetchInventoryWasteReportFailure,
  fetchInventoryWasteReportCSV,
  fetchInventoryWasteReportCSVSuccess,
  fetchInventoryWasteReportCSVFailure,
} from "../../store/reports/actions";

import { STARTING_PAGE, DEBOUNCE_SEARCH } from '../../constants/constants';
import { withRouter } from "utils/WithRouter";

export class ReportWasteContainer extends Component {

  // ---------------------------------------------------------------------------
  // Initialization
  // ---------------------------------------------------------------------------
  constructor(props){
    super(props);
    this.state = {
      page: 1,
      filterFrom: moment().subtract(1, 'week').format('YYYY-MM-DD'),
      filterTo: moment().format('YYYY-MM-DD'),
      searchInventory: '',
      selectedWasteCategoryIndex: undefined,
      selectedWasteCategory: undefined,
      selectedPlant: '',
      selectedLot: '',
    };

    this.changeSearch = _.debounce(() => {
      this.searchRefresh()
      this.updateQueryString();
    }, DEBOUNCE_SEARCH);
  }

  componentDidMount() {
    const params = queryString.parse(this.props.location.search);
    const filterFrom = params.from ? params.from : this.state.filterFrom;
    const filterTo = params.to ? params.to : this.state.filterTo;
    const searchInventory = params.inventory ? params.inventory : undefined;
    const selectedWasteCategory = params.selectedWasteCategory ? params.selectedWasteCategory : undefined;
    const selectedWasteCategoryIndex = params.selectedWasteCategoryIndex ? params.selectedWasteCategoryIndex : undefined;
    const page = params.page ? params.page : STARTING_PAGE;
    const selectedPlant = params.plant ? params.plant : this.state.selectedPlant;
    const selectedLot = params.lot ? params.lot : this.state.selectedLot;

    // Fetch initial page
    this.setState(
      { page, filterFrom, filterTo, searchInventory, selectedWasteCategory, selectedWasteCategoryIndex, selectedPlant, selectedLot },
      () => {
        this.props.getFilteredWasteReport(page, searchInventory, filterFrom, filterTo, selectedWasteCategory, selectedPlant, selectedLot);
      }
    );

    this.props.fetchWasteCategories();
    this.props.fetchInventoryWasteReportCSV(searchInventory, filterFrom, filterTo, selectedWasteCategory, selectedPlant, selectedLot);
  }

  // ---------------------------------------------------------------------------
  // Filters handling
  // ---------------------------------------------------------------------------

  onFromDateChange = (event) => {
    let filterFrom = event.target.value ? event.target.value : this.state.filterFrom;
    this.setState({ filterFrom, page: STARTING_PAGE }, () => {
        this.updateQueryString();
        this.searchRefresh();
    });
  };

  onToDateChange = (event) => {
    let filterTo = event.target.value ? event.target.value : this.state.filterTo;
    this.setState({ filterTo, page: STARTING_PAGE }, () => {
        this.updateQueryString();
        this.searchRefresh();
    });
  };

  onSearchChange = (event) => {
    let searchInventory = event.target.value ? event.target.value : '';
    this.setState({ searchInventory, page: STARTING_PAGE }, () => {
        this.changeSearch();
    });
  };

  onWasteCategoryChange = (event) => {
    let selectedWasteCategoryIndex = parseInt(event.target.value, 10) !== -1 ? event.target.value : undefined,
      selectedWasteCategory = selectedWasteCategoryIndex
        ? this.props.wasteCategoriesList.categories[selectedWasteCategoryIndex].id
        : undefined;
    this.setState({ selectedWasteCategoryIndex, selectedWasteCategory }, () => {
      this.searchRefresh();
      this.updateQueryString();
    });
  };

  onPlantChange = (event) => {
    const selectedPlant = event.target.value ? event.target.value : "";
    this.setState({ selectedPlant }, () => {
      this.changeSearch();
    });
  };

  onLotChange = (event) => {
    const selectedLot = event.target.value ? event.target.value : "";
    this.setState({ selectedLot }, () => {
      this.changeSearch();
    });
  };

  searchRefresh = () => {
    const { page, searchInventory, filterFrom, filterTo, selectedWasteCategory, selectedPlant, selectedLot } = this.state;
    this.props.getFilteredWasteReport(page, searchInventory, filterFrom, filterTo, selectedWasteCategory, selectedPlant, selectedLot);
    this.props.fetchInventoryWasteReportCSV(searchInventory, filterFrom, filterTo, selectedWasteCategory, selectedPlant, selectedLot);
  };

  updateQueryString = () => {
    const {
      filterFrom,
      filterTo,
      searchInventory,
      page,
      selectedWasteCategory,
      selectedWasteCategoryIndex,
      selectedPlant,
      selectedLot,
    } = this.state;
    let params = {};
    if (filterFrom) params.from = filterFrom;
    if (filterTo) params.to = filterTo;
    if (searchInventory) params.inventory = searchInventory;
    if (selectedWasteCategory) params.selectedWasteCategory = selectedWasteCategory;
    if (selectedWasteCategoryIndex) params.selectedWasteCategoryIndex = selectedWasteCategoryIndex;
    if (selectedPlant) params.plant = selectedPlant;
    if (selectedLot) params.lot = selectedLot;
    params.page = page;
    this.props.history.push({ search: queryString.stringify(params) });
  };

  // ---------------------------------------------------------------------------
  // Pagination
  // ---------------------------------------------------------------------------
  handlePageRequest = (data) => {
    let page = data.selected + 1;
    if(page !== this.state.page){
      this.setState({ page }, () => {
          this.updateQueryString();
          this.searchRefresh();
      });
    };
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render(){
    if (!this.state.filterFrom || !this.state.filterTo){
      return <Spinner />;
    } else {
      return (
        <div>
          <div className="card mb-2">
            <ReportHeader title='Waste Report'
                          actionTitle='Export CSV'
                          actionClass='btn btn-primary m-0'
                          headers={['Id', 'ItemDesc', 'ItemNumber', 'Station', 'Quantity', 'Category', 'DeleteDate', 'User', 'PackingDate']}
                          csvData={this.props.inventoryWasteReportCSV.wasteCSV}
                          csvLoading={this.props.inventoryWasteReportCSV.loading}
                          filename={`${moment(this.state.filterFrom).format('MMM DD')}-${moment(this.state.filterTo).format('MMM DD')}.csv`}/>
            <Filter
              searchLabel="Search"
              searchPlaceholder="Item name"
              searchVal={this.state.searchInventory}
              onSearchChange={this.onSearchChange}
              dateLabel="From Date"
              dateVal={this.state.filterFrom}
              onDateChange={this.onFromDateChange}
              dateLabel2="To Date"
              dateVal2={this.state.filterTo}
              onDateChange2={this.onToDateChange}
              dropdownLabel="Waste Category"
              dropdownPlaceholder="All categories"
              dropdownVal={this.state.selectedWasteCategoryIndex}
              onDropdownChange={this.onWasteCategoryChange}
              dropdownOptions={this.props.wasteCategoriesList.categories}
              searchLabel3="Plant"
              searchPlaceholder3="Search by plant"
              searchVal3={this.state.selectedPlant}
              onSearchChange3={this.onPlantChange}
              searchLabel4="Lot"
              searchPlaceholder4="Search by lot"
              searchVal4={this.state.selectedLot}
              onSearchChange4={this.onLotChange}
            />
          </div>
          <ReportWaste inventoriesList={this.props.inventoryWasteReport.wasteReport}/>
          {this.props.inventoryWasteReport.pages > 1 &&
            <ReactPaginate pageCount={this.props.inventoryWasteReport.pages}
                            pageRangeDisplayed={2}
                            marginPagesDisplayed={1}
                            previousLabel="<"
                            nextLabel=">"
                            onPageChange={this.handlePageRequest}
                            initialPage={this.state.page-1}
                            disableInitialCallback={true}
                            containerClassName="pagination"
                            pageClassName="page-item"
                            pageLinkClassName="page-link"
                            activeClassName="page-item active"
                            previousClassName="paginate_button previous"
                            nextClassName="paginate_button next"
                            disabledClassName="page-item disabled"
                            forcePage={this.state.page-1}/>
          }
          {this.props.inventoryWasteReport.loading ? <Spinner /> : null }
        </div>
      );
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    inventoryWasteReport: state.reports.inventoryWasteReport,
    inventoryWasteReportCSV: state.reports.inventoryWasteReportCSV,
    wasteCategoriesList: state.inventories.wasteCategoriesList,
    currentUser: state.auth.currentUser
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFilteredWasteReport: (page, search='', from, to, category=undefined, plant, lot) => {
      dispatch(fetchInventoryWasteReport(page, search, from, to, category, plant, lot)).payload.then((response) => {
        dispatch(fetchInventoryWasteReportSuccess(response.data));
      }, (error) => {
        dispatch(fetchInventoryWasteReportFailure(error));
      });
    },
    fetchWasteCategories: () => {
      dispatch(fetchWasteCategories()).payload.then((response) => {
        dispatch(fetchWasteCategoriesSuccess(response.data))
      }, (error) => {
        dispatch(fetchWasteCategoriesFailure(error));
      });
    },
    fetchInventoryWasteReportCSV: (search='', from, to, category=undefined, plant, lot) => {
      dispatch(fetchInventoryWasteReportCSV(search, from, to, category, plant, lot)).payload.then((response) => {
        dispatch(fetchInventoryWasteReportCSVSuccess(response.data));
      }, (error) => {
        dispatch(fetchInventoryWasteReportCSVFailure(error));
      });
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ReportWasteContainer));
